import { faPlus } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import { AppTextField } from '../form/appTextField';
import { required } from '../form/formValidations';
import FormModal from '../modal/formModal';

// eslint-disable-next-line react/prefer-stateless-function
export default class NewShopForm extends React.Component {
  public render() {
    return (
      <FormModal
        formId={FormId.ShopForm}
        formTitle="New Shop"
        buttonIcon={faPlus}
        invertedButtonColours
        submitActionType={DataRequestActionTypes.NewShopRequested}
      >
        <AppTextField name="name" label="Name" validate={[required]} />
        <AppTextField name="url" label="URL" validate={[required]} />
        <AppTextField name="consumerKey" label="Consumer Key" validate={[required]} />
        <AppTextField name="consumerSecret" label="Consumer Secret" validate={[required]} />
      </FormModal>
    );
  }
}
